import { SoundPlugin } from '@jollywise/jollygoodgame/src/components/sound/SoundPlugin';

export class SoundControllerSesame extends SoundPlugin {
  playMusic(id, opts = {}) {
    if (this._backgroundmusic == id) return false;
    this._backgroundmusic = id;
    return super.playMusic(id, opts);
  }

  stopSFXById(id) {
    console.log('stopSFXById');
    const sounds = this.audioGroups[SFX_GROUP].sounds.filter((s) => s.id == id);
    console.log(sounds);
  }
}
